<template>
  <div class="public-products default-page">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="container-fluid">
              <div class="row filter-row">
                <div class="col-12" style="text-align: center">
                  <h3>Vantagens de ser assinante</h3>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <div v-html="page.content" class="text-content"></div>
                </div>
              </div>
              <div class="row magazines-row">
                <div class="col-12">
                  <div class="magazines d-flex justify-content-center align-items-center">
                    <div v-for="item in magazines" v-bind:key="item.id" class="magazine">
                      <router-link
                        class="primary-a"
                        :to="{ name: 'public.magazine-editions', params:{id: item.id} }"
                      >
                        <img :src="item.cover_url" alt />
                        <div class="name">{{item.name}}</div>
                      </router-link>
                      <router-link
                        class="secondary-a"
                        :to="{ name: 'public.contact', params:{subject: `Solicito uma proposta comercial referente ao ${item.name}`} }"
                      >
                      <i class="fa fa-envelope" aria-hidden="true"></i> Solicite uma proposta
                      </router-link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "public-products",
  data() {
    return {
      page: {},
      magazines: []
    };
  },
  mounted() {
    this.getPageContent();
    this.getMagazines();
  },
  methods: {
    getPageContent: function() {
      axios
        .get(`${process.env.VUE_APP_API_HOST}/api/content_pages_public/2`)
        .then(response => {
          this.page = response.data;
        });
    },
    getMagazines: function() {
      axios
        .get(
          `${process.env.VUE_APP_API_HOST}/api/magazines_public?page[number]=1&page[size]=50`
        )
        .then(response => {
          this.magazines = response.data.data;
        });
    }
  }
};
</script>

<style lang="scss">
@import "@/styles/General.scss";

.public-products {
  .magazines-row {
    margin-top: 35px;
    .magazines {
      .magazine {
        text-align: center;
        a {
          color: #5f6064;
          text-decoration: none;
        }
        a:hover {
          font-weight: bold;
        }
        .secondary-a{
          margin-top: 6px;
        }
        img {
          width: 40%;
        }
        .name {
          margin-top: 8px;
          font-size: 16px;
        }
      }
    }
  }
}
</style>